// extracted by mini-css-extract-plugin
export default {"inviteBtn":"form_inviteBtn__0dsdH","street":"form_street__KS-JK"};